export const couponOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  menuWidth:380,
  // labelWidth: "150",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "优惠券名称",
      prop: "name",
      search: true,
    },
    {
      label: "优惠码",
      prop: "code",
    },
    {
      label: "类型",
      prop: "type",
      search: true,
      dicData: [
        {
          label: "优惠券",
          value: 0,
        },
        {
          label: " 抵扣券",
          value: 1,
        },
      ],
    },
   
    {
      label: "开始时间",
      prop: "startDate",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "结束时间",
      prop: "endDate",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
    },
    {
      label: "优惠说明",
      prop: "remarks",
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
